import poster1 from '../assets/poster-7.jpg';
import poster2 from '../assets/poster-9.jpg';

const list = [poster1, poster2];

const Challenge = () => {
  return (
    <section
      className='py-20 bg-black text-text-main'
      id='challenge'
    >
      <div className='container mx-auto px-4 max-w-6xl'>
        <div className='text-center mb-16'>
          <h2 className='text-3xl md:text-4xl font-bold text-text-main mb-4'>
            <span className='text-accent'>TheChamps</span> Challenges
          </h2>
          <p className='text-lg text-gray-300 max-w-2xl mx-auto'>
            Choose the plan that works best for you and start your fitness
            journey today
          </p>
        </div>

        <div className='flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-8'>
          {list.map((item, i) => (
            <div
              key={i}
              className='aspect-[2/3] w-full max-w-[320px] sm:w-[30vw] sm:min-w-[280px] sm:max-w-[420px] relative'
            >
              <img
                src={item}
                alt='poster'
                className='object-cover object-center w-full h-full rounded-md shadow-lg'
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Challenge;
